import React, { useState } from 'react';
import './FAQAccordion.css';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQAccordion: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems: FAQItem[] = [
    {
      question: "Ile kosztuja zajecia i czy to sie oplaca?",
      answer: "Zajecia grupowe kosztuja 65 PLN za 60 minut, zajecia indywidualne 150 PLN za 60 minut. To mniej niz korepetycje prywatne, a efekty sa lepsze dzieki sprawdzonej metodologii. Pierwsza lekcja jest zawsze GRATIS."
    },
    {
      question: "Jak szybko moje dziecko zacznie osiagac lepsze wyniki?",
      answer: "Wiekszosc uczniow poprawia oceny juz po 2-3 tygodniach regularnych zajec. Srednia poprawa to 1,3 stopnia w ciagu pierwszego miesiaca."
    },
    {
      question: "Czy moje dziecko nadrobi zaleglosci, jesli ma slabe podstawy?",
      answer: "Specjalizujemy sie w nadrabianiu zaleglosci. Nasz program jest zaprojektowany dla uczniow z lukami w podstawach. 89% uczniow osiaga oceny dobre lub bardzo dobre w ciagu semestru."
    },
    {
      question: "Co jesli matematyka to najwiekszy koszmar mojego dziecka?",
      answer: "Nasi nauczyciele sa ekspertami w pracy z uczniami, ktorzy boja sie matematyki. Uzywamy metody 'malych krokow' i pozytywnego wzmacniania. Po miesiacu 94% uczniow deklaruje, ze matematyka przestala byc dla nich trudna."
    },
    {
      question: "Jak przygotowujecie do matury z matematyki?",
      answer: "Nasz program maturalny obejmuje wszystkie typy zadan, techniki rozwiazywania pod presja czasu i symulacje egzaminow. 98% naszych uczniow zdaje mature powyzej oczekiwan."
    },
    {
      question: "Ile uczniow jest w grupie?",
      answer: "Nasze grupy licza maksymalnie 6 uczniow, co pozwala na indywidualne podejscie do kazdego z nich. Kazdy uczen otrzymuje uwage nauczyciela i moze aktywnie uczestniczyc w zajeciach."
    }
  ];

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="awesome-faq-section">
      <div className="awesome-faq-container">
        <div className="awesome-faq-header">
          <h2 className="awesome-faq-title">Czeste pytania</h2>
          <p className="awesome-faq-subtitle">
            Odpowiedzi na pytania, ktore zadaje 90% rodzicow
          </p>
        </div>

        <div className="awesome-faq-list">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className={`awesome-faq-item ${openIndex === index ? 'open' : ''}`}
            >
              <button
                className="awesome-faq-question"
                onClick={() => toggleItem(index)}
                aria-expanded={openIndex === index}
              >
                <span>{item.question}</span>
                <svg
                  className="awesome-faq-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              <div className="awesome-faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="awesome-faq-cta">
          <p className="awesome-faq-cta-text">Masz inne pytanie?</p>
          <a href="tel:+48532533220" className="awesome-faq-cta-link">
            Zadzwon: +48 532 533 220
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQAccordion;
